<template>
    <component :is="parentWrapper" class="pa-0">
        <v-container fluid grid-list-xs>
            <v-layout row wrap>
                <v-flex
                    :class="shippingTypeStyle()"
                    v-for="shippingType in getShippingTypes"
                    v-bind:key="shippingType.id"
                >
                    <v-card :flat="flatCards" class="shipping-flat-cards">
                        <v-card-text
                            v-if="shippingType.name === 'Pickup' && $country.getCountry() === 'CH'"
                            style="display: flex; margin-right: 0;"
                            class="pl-2"
                        >
                            <i
                                class="material-icons pl-2 pb-2"
                                style="align-self: center; padding-left: 25px; font-size: 41px;"
                            >
                                info
                            </i>
                            <div class="shipping-type-text pl-3" style="padding-left: 22px; font-size: 18px;">
                                <div style="font-weight: bold;">
                                    {{'BESTELLUNGEN AUS DER SCHWEIZ KÖNNEN NUR VOR ORT ABGEHOLT WERDEN' | translation}}
                                </div>
                                <div>
                                    {{'Lieber Kunde. Ihr Paket ist ab 16 Uhr im Grillshop Dornbirn für Sie abholbereit.' | translation}}
                                </div>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <v-container>
            <v-layout row wrap>

                <v-flex md6>
                    <p style="font-weight: bold"> {{ 'Billing address' | translation }} </p>
                    <v-card :flat="flatCards">
                        <v-card-text>
                            <div>
                                {{ billingAddress ? billingAddress.firstName : '' }}
                                {{ billingAddress ? billingAddress.lastName : '' }}
                            </div>
                            <div>
                                {{ billingAddress ? billingAddress.street : '' }}
                                {{ billingAddress ? billingAddress.houseNumber : '' }}
                            </div>
                            <div>
                                {{ billingAddress ? billingAddress.postCode : '' }}
                                {{ billingAddress ? billingAddress.city : '' }}
                            </div>
                            <div>
                                {{
                                    billingAddress
                                        ? $country.getCountryNameBy('iso_2', billingAddress.country)
                                        : '' | translation
                                }}
                            </div>
                            <div v-if="customerData.email">{{ customerData.email }}</div>
                            <div v-else-if="registrationEmail">{{ registrationEmail }}</div>
                        </v-card-text>
                        <v-card-actions v-if="!paymentSummary">
                            <a @click.prevent="$emit('goToStep', { route: 'address' })" href="#">{{
                                    'Change Address' | translation
                                }}</a>
                        </v-card-actions>
                    </v-card>
                </v-flex>

                <v-flex md6 v-if="$country.getCountry() !== 'CH' && (getCurrentShippingType !== '1001')">
                    <p style="font-weight: bold">{{ 'Lieferadresse' | translation }}</p>
                    <v-card :flat="flatCards">
                        <v-card-text v-if="shippingAddresses.length === 1 || !isUserLoggedIn">
                            <div>
                                {{ shippingAddress ? shippingAddress.firstName : '' }}
                                {{ shippingAddress ? shippingAddress.lastName : '' }}
                            </div>
                            <div>
                                {{ shippingAddress ? shippingAddress.company : ''}}
                            </div>
                            <div>
                                {{ shippingAddress ? shippingAddress.street : '' }}
                                {{ shippingAddress ? shippingAddress.houseNumber : '' }}
                            </div>
                            <div>
                                {{ shippingAddress ? shippingAddress.postCode : '' }}
                                {{ shippingAddress ? shippingAddress.city : '' }}
                            </div>
                            <div>
                                {{
                                    shippingAddress
                                        ? $country.getCountryNameBy('iso_2', shippingAddress.country)
                                        : '' | translation
                                }}
                            </div>
                            <div v-if="customerData.email">{{ customerData.email }}</div>
                            <div v-else-if="registrationEmail">{{ registrationEmail }}</div>
                        </v-card-text>
                        <v-card-text v-else>
                            <ShippingAddressRadioGroup :addresses="shippingAddresses" />
                        </v-card-text>
                        <v-card-actions  v-if="!paymentSummary">
                            <a @click.prevent="$emit('goToStep', { route: 'address' })" href="#">{{
                                    'Change Address' | translation
                                }}</a>
                        </v-card-actions>
                    </v-card>
                </v-flex>

                <v-flex md6 v-if="$country.getCountry() === 'CH' || shipping === '1001'">
                    <p style="font-weight: bold">{{ 'Hier können Sie Ihr Paket abholen' | translation }}</p>
                    <v-card :flat="flatCards">
                        <v-card-text v-if="shippingAddresses.length === 1 || !isUserLoggedIn">
                            <div>
                                {{ 'pickup_address_company' | translation }}
                            </div>
                            <div>
                                {{ 'pickup_address_street' | translation }}
                            </div>
                            <div>
                                {{ 'pickup_address_zip_city' | translation }}
                            </div>
                            <p></p>
                            <div style="font-weight: bold">
                                {{ 'Bei Fragen rufen Sie uns bitte an' | translation }}
                            </div>
                            <div>
                                {{ 'pickup_address_phone' | translation }}
                            </div>
                            <v-card-actions> </v-card-actions>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>

        <v-container grid-list-md white mt-3 fluid>
            <p class="title" v-if="displayLabel">
                {{ 'shopping cart' | translation }}
            </p>
            <basket-items
                :selectableShipping="false"
                coupon
                shipping-provider-selection
                :getPriceForAddress="true"
                :shippingTypes="getShippingTypes"
                v-model="shipping"
            ></basket-items>
        </v-container>

        <v-container fluid grid-list-md white mt-3 v-if="shippingPrices && Object.values(shippingPrices).length">
            <v-layout row wrap>
                <v-flex md6> </v-flex>
                <v-flex md6>
                    <p class="title">{{ 'payment method' | translation }}</p>
                    <payment
                        v-if="active"
                        @success="$emit('onNextStep', $event)"
                        @received="$emit('onNextStep', { ...$event, props: { paid: false } })"
                        @editAddress="onEditAddress"
                    ></payment>
                </v-flex>
            </v-layout>
        </v-container>
    </component>
</template>

<script>
import StepBase from '@breakmedia/prime-vue-stepper/src/StepBase';
import ShippingAddressRadioGroup from '@breakmedia/prime-vue-checkout/src/AddressStep/ShippingAddressRadioGroup';
import { mapState, mapGetters, mapActions } from 'vuex';
import Login from '@breakmedia/prime-vue-customer/src/Login/LoginForm';
import ShippingSelector from '@breakmedia/prime-vue-basket/src/ShippingSelector';

export default {
    //do not set the name - it will break the integration with vuetify stepper
    extends: StepBase,
    components: {
        ShippingAddressRadioGroup,
    },
    created() {
        this.loadCustomerData();
        this.$store.dispatch('Grillshop/queryShippingTypes');
    },
    data() {
        return {
            radiotest: null,
            products: [],
            merchantsData: {},
            listReady: false,
            selectedAddress: 0,
        };
    },
    props: {
        checkedType: null,
        displayLabel: true,
        route: {
            default: 'summary',
        },
        flatCards: Boolean,
    },
    computed: {
        ...mapState('Customer', ['customerData']),
        ...mapState('Payment', ['paymentSummary']),
        ...mapState(ShippingSelector.name, ['shippingPrices']),
        ...mapState('Registration', {
            registrationEmail: state => state.email,
        }),
        ...mapGetters(Login.name, ['isUserLoggedIn']),
        shippingAddresses() {
            return this.$order.getShippingAddresses();
        },
        billingAddress() {
            return this.$order.getBillingAddress();
        },
        shippingAddress() {
            return this.$order.getShippingAddress();
        },
        ...mapGetters('Grillshop', ['getShippingTypes', 'getCurrentShippingType']),
        shipping: {
            get() {
                return this.getCurrentShippingType;
            },
            set(value) {
                this.$store.commit('Grillshop/setCurrentShippingType', value);
            },
        },
    },
    methods: {
        ...mapActions('Customer', ['loadCustomerData']),
        onEditAddress(event) {
            this.$emit('goToStep', {
                route: 'address',
                props: {
                    displayHouseNumberField: true,
                    displayBillingForm: true,
                    redirect: {
                        route: 'summary',
                        query: {
                            payment: event,
                        },
                    },
                },
            });
        },
        shippingTypeStyle() {
            return this.$country.getCountry() === 'CH' ? 'md12' : 'xs6';
        },
    },
};
</script>

<style>
.shipping-type {
    display: inline-flex;
    background-color: #ec6707;
    height: 80px;
}
.shipping-flat-cards.v-card {
    display: flex;
    color: #ffffff;
    background-color: #ec6707;
}

.radio-group-full-width .v-input__control {
    width: 100%;
}

.radio-buttons-shipping .accent--text,
.radio-buttons-shipping .v-input--selection-controls__ripple {
    color: #fff !important;
    caret-color: #fff !important;
}

.radio-buttons-shipping input,
.radio-buttons-shipping .v-icon {
    color: #fff !important;
}



.shipping-type-headline {
    font-weight: bold;
}

.shipping-type-icon {
    align-self: center;
    font-size: 48px;
}

.v-input--radio-group--column .radio-buttons-shipping.v-radio:not(:last-child):not(:only-child) {
    margin-bottom: 0;
}

.shipping-card {
    display: flex;
    margin-right: 0;
}

</style>
